<template>
  <section class="occupations section">
    <div class="container">
      <h1 class="title">Occupations</h1>
      <div class="d-flex justify-content-between mb-4 flex-wrap">
        <div
          class="d-flex align-items-center mr-auto text-dark col-12 col-md-auto mb-3 mb-md-0"
        >
          <span>
            <b v-if="!loading">
              <i class="fas fa-spin fa-circle-notch" v-if="busy"></i>
              {{ busy ? "" : occupations.length }}/{{ total }}</b
            >
            <i class="fas fa-spin fa-circle-notch" v-if="loading"></i>
            Occupation{{ loading || total != 1 ? "s" : "" }}
          </span>
        </div>
        <button
          @click="OpenNewOccupationModal()"
          class="btn btn-sm btn-success"
          v-if="!loading"
        >
          <i class="fas fa-plus"></i> Add Occupation
        </button>
      </div>
      <loading v-if="loading" class="white-bg shadow-card" />
      <div
        class="overflow-auto desktop-shadow-card rounded"
        v-if="occupations.length > 0 && !loading"
      >
        <table class="table table-striped mb-0 rounded shadow-card">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="occupation in occupations" :key="occupation.id">
              <td>{{ occupation.id }}</td>
              <td>
                <span
                  class="cursor"
                  v-if="storeOccupations.tmp.id != occupation.id"
                  v-on:click="editOccupation(occupation)"
                  ><i
                    class="fa fa-info-circle mr-2"
                    v-tooltip.top="
                      'Click occupation name to edit then press enter'
                    "
                  ></i
                  >{{ occupation.name }}</span
                >
                <div class="row">
                  <div class="col">
                    <input
                      type="text"
                      ref="occupationName"
                      v-model="occupation.name"
                      class="form-control w-100"
                      v-if="
                        storeOccupations.tmp.editing &&
                        storeOccupations.tmp.id == occupation.id
                      "
                      v-on:keyup.enter="saveOccupation(occupation)"
                      v-on:keyup.esc="cancelEditing(occupation)"
                    />
                  </div>
                  <div class="col-2">
                    <div
                      class="text-secondary my-3"
                      v-if="saving && storeOccupations.tmp.id == occupation.id"
                    >
                      <span
                        class="spinner-border spinner-border-sm mr-3"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <strong>Saving...</strong>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <mugen-scroll :handler="loadMore" :should-handle="!busy && !loading">
          <alert
            v-if="busy"
            class="text-center p-2 mb-0 mobile-tablet-loadmore mobile-tablet-shadow-card"
            ><i class="fas fa-spin fa-circle-notch mr-2"></i>Loading more
            occupations...</alert
          >
        </mugen-scroll>
      </div>
    </div>
    <modal id="add-occupation-modal">
      <h2 class="text-center">Add New Occupation</h2>
      <form autocomplete="false">
        <div class="col-md-12">
          <input
            class="form-control"
            v-model="newOccupationName"
            type="text"
            autocomplete="off"
            required
            placeholder="Occupation Name"
          />
        </div>
        <div class="col-md-12 text-center">
          <button
            type="submit"
            class="my-4 col-md-12 btn btn-primary"
            @click.prevent="createNewOccupation"
            :disabled="!newOccupationName.trim().length"
          >
            <span>
              <span
                class="spinner-border spinner-border-sm mr-3"
                role="status"
                aria-hidden="true"
                v-if="saving"
              ></span>
              <i class="mr-2 fas fa-check-circle fa-fw" v-if="!saving"></i
              >Add</span
            >
          </button>
        </div>
      </form>
    </modal>
  </section>
</template>
<script>
import { mapState, mapActions } from "vuex";
import MugenScroll from "vue-mugen-scroll";

export default {
  name: "occupations",
  components: {
    MugenScroll,
  },
  data() {
    return {
      newOccupationName: "",
      limit: 50,
      busy: false,
    };
  },
  computed: {
    ...mapState(["loading", "saving"]),
    ...mapState({
      occupations: (state) => state.occupations.pagination.data,
      storeOccupations: (state) => state.occupations,
      current: (state) => state.occupations.pagination.current,
      total: (state) => state.occupations.pagination.total || 0,
    }),
  },
  mounted() {
    this.getOccupations({ limit: this.limit });
  },
  methods: {
    ...mapActions({
      getOccupations: "occupations/all",
    }),
    editOccupation: function (o) {
      this.storeOccupations.tmp = {
        id: o.id,
        editing: true,
        old: o.name,
      };
      let vm = this;
      setTimeout(() => {
        vm.$refs.occupationName[0].focus();
      }, 0);
    },
    createNewOccupation: function () {
      this.$store.commit("SET_SAVING_STATE", true, { root: true });
      this.$store
        .dispatch("occupations/create", { name: this.newOccupationName })
        .then((success) => {
          if (success) {
            this.$store.dispatch("hideModal", "add-occupation-modal");
          }
        });
    },
    OpenNewOccupationModal: function () {
      this.newOccupationName = "";
      this.$store.dispatch("showModal", "add-occupation-modal");
    },
    saveOccupation: function (o) {
      this.$store.commit("SET_SAVING_STATE", true, { root: true });
      this.$store.dispatch("occupations/update", { id: o.id, name: o.name });
    },
    cancelEditing: function (o) {
      o.name = this.storeOccupations.tmp.old;
      this.$store.commit("occupations/CANCEL_EDITING");
    },
    loadMore() {
      if (this.occupations.length < this.total) {
        this.busy = true;
        this.getOccupations({
          limit: this.limit,
          page: this.current + 1,
        }).then(() => {
          this.busy = false;
        });
      }
    },
  },
};
</script>
